import request from '@/utils/request'

export const send_unused_gifts = (id: number) =>
  request({
    url: `/admin/programs/${id}/resend_unused_gifts`,
    method: 'post'
  })